import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ItemsForm, ItemsRow, ItemsUpdate } from "../types";
import { initialItemsForm, initialState } from "./initialState";

export const sliceKey = "itemsState";

const itemsSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getItemsList(state) {
      state.loading = true;
      state.error = null;
    },

    getItemsListSuccess(state, action: PayloadAction<ItemsRow[]>) {
      state.loading = false;
      state.list = action.payload;
      state.error = null;
    },

    getItemsListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialItemsForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof ItemsForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialItemsForm;
    },

    addItem(state) {
      state.saving = true;
      state.error = null;
    },

    addItemSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialItemsForm;
      state.error = null;
    },

    addItemError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },

    updateItem(state, _action: PayloadAction<ItemsUpdate>) {
      state.saving = true;
      state.error = null;
    },

    updateItemSuccess(state) {
      state.saving = false;
      state.error = null;
    },

    updateItemError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },

    getItemDetail(state, _action: PayloadAction<number>) {
      state.detailLoading = true;
      state.detailError = null;
      state.detail = null;
    },

    getItemDetailSuccess(state, action: PayloadAction<ItemsRow>) {
      state.detailLoading = false;
      state.detail = action.payload;
      state.detailError = null;
    },

    getItemDetailError(state, action: PayloadAction<string>) {
      state.detailLoading = false;
      state.detail = null;
      state.detailError = action.payload;
    },

    clearItemDetail(state) {
      state.detail = null;
      state.detailLoading = false;
      state.detailError = null;
    },

    deleteItem(state, _action: PayloadAction<number>) {
      state.saving = true;
      state.error = null;
    },

    deleteItemSuccess(state, action: PayloadAction<number>) {
      state.saving = false;
      state.error = null;
      state.list = state.list.filter((item) => item.itemId !== action.payload);
      if (state.detail?.itemId === action.payload) {
        state.detail = null;
        state.detailLoading = false;
        state.detailError = null;
      }
    },

    deleteItemError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: itemsActions, reducer } = itemsSlice;
